import React, { Component } from 'react';



function Footer(){
    return(
        <React.Fragment>
            <div className="container col-xxl-10 py-4 px-2">
                <br/>
                <br/>
                <p className="text-center">Designed And Built By Keder</p>
            </div>
        </React.Fragment>
    )
}

export default Footer